//Install
import React, { Component } from "react";
//Install
import { ReactComponent as World } from "../../../../Media/Icon/001.svg";
//Install
import { ReactComponent as Arrow } from "../../../../Media/Icon/002.svg";

//Element
class Language extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S0u16d C96Q4r U080Kf d721Vx pEO064 a527eB cH8711 y171vm" },
            //Element
            React.createElement("span", { className: "t1w441" },
                //Element
                "Azerbaijan"
            ),
            //Element
            React.createElement(World, {}),
            //Element
            React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB gBt584 w598wt" },
                //Element
                React.createElement("li", { className: "S6pt64 C96Q4r" },
                    //Element
                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/" },
                        //Element
                        "Türkiye",
                        //Element
                        React.createElement(Arrow, {})
                    )
                ),
                //Element
                React.createElement("li", { className: "S6pt64 C96Q4r" },
                    //Element
                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en" },
                        //Element
                        "United Kingdom",
                        //Element
                        React.createElement(Arrow, {})
                    )
                ),
                //Element
                React.createElement("li", { className: "S6pt64 C96Q4r" },
                    //Element
                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az" },
                        //Element
                        "Azerbaijan",
                        //Element
                        React.createElement(Arrow, {})
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Language;